import { Court, DateOption } from 'modules/jogador/booking/types';

export const ARENA_NAME = 'Arena Praia Norte';
export const SPORT_LABEL = 'Beach Tennis';

export const DATE_OPTIONS: DateOption[] = [
  { id: '11', weekday: 'qua', day: '11' },
  { id: '12', weekday: 'qui', day: '12' },
  { id: '13', weekday: 'sex', day: '13' },
  { id: '14', weekday: 'sáb', day: '14' },
  { id: '15', weekday: 'dom', day: '15' },
];

export const COURTS: Court[] = [
  {
    id: 'areia-1',
    name: 'Areia 1 · descoberta',
    pricePerHour: 60,
    slots: [
      { time: '17:00', status: 'occupied' },
      { time: '18:00', status: 'available' },
      { time: '19:00', status: 'available' },
      { time: '20:00', status: 'occupied' },
    ],
  },
  {
    id: 'areia-3',
    name: 'Areia 3 · coberta',
    pricePerHour: 80,
    slots: [
      { time: '17:00', status: 'available' },
      { time: '18:00', status: 'available' },
      { time: '19:00', status: 'fixed' },
      { time: '20:00', status: 'available' },
    ],
  },
  {
    id: 'quadra-5',
    name: 'Quadra 5 · pickleball',
    pricePerHour: 55,
    slots: [
      { time: '17:00', status: 'available' },
      { time: '18:00', status: 'available' },
      { time: '19:00', status: 'available' },
      { time: '20:00', status: 'occupied' },
    ],
  },
];

export const SERVICE_FEE = 3.2;
